var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import storeUtil from './store';
import imsdkUtil from './imsdk';
import intlUtil from './intl';
import event from './event';
import { IMState } from "./interface/state-interface";
import './shims.d';
export { default as ImCoreStateClass } from './store/im-core-state';
export { getMtopAccsConfig } from './sdk';
import * as EVENT from './event/constant';
export { EVENT, IMState, intlUtil as intl, };
var ImCore = (function () {
    function ImCore(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.store, _d = (_c === void 0 ? {} : _c).stateClass, stateClass = _d === void 0 ? function () { } : _d, _e = _b.imsdk, _f = (_e === void 0 ? {} : _e).config, config = _f === void 0 ? {} : _f;
        this.im = {};
        this.intl = intlUtil;
        this.event = event;
        this.stateClass = stateClass;
        this.imsdkConfig = config;
    }
    ImCore.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var im, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.initStore(this.stateClass);
                        this.initIntl();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4, this.initImSDK(this.imsdkConfig)];
                    case 2:
                        im = _a.sent();
                        if (!im) {
                            this.store.updateData({ isImError: true, isImLoading: false, imState: IMState.error });
                            console.error('Im init failed, config:', this.imsdkConfig);
                            throw new Error('init Failed');
                        }
                        this.im = im;
                        this.store.ImSDK = im;
                        this.store.updateData({
                            notLogin: false,
                            loginUser: im._loginUser || {}
                        });
                        return [2, Promise.resolve(this)];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1.type === 'USER_NOT_LOGIN') {
                            this.store.updateData({
                                notLogin: true,
                                isImLoading: false,
                                imState: IMState.notLogin
                            });
                        }
                        else {
                            this.store.updateData({
                                isImLoading: false,
                                isImError: true,
                                imState: IMState.error
                            });
                        }
                        throw err_1;
                    case 4: return [2];
                }
            });
        });
    };
    ImCore.prototype.initStore = function (stateClass) {
        if (stateClass === void 0) { stateClass = this.stateClass; }
        this.store = storeUtil.stateFactory(stateClass);
        return this;
    };
    ImCore.prototype.initImSDK = function (imsdkConfig) {
        if (imsdkConfig === void 0) { imsdkConfig = this.imsdkConfig; }
        return imsdkUtil.init(imsdkConfig, this.store);
    };
    ImCore.prototype.initIntl = function (lang) {
        if (lang === void 0) { lang = this.imsdkConfig.lang || ''; }
        return this.intl.setLang(lang);
    };
    ImCore.imsdkUtil = imsdkUtil;
    return ImCore;
}());
export default ImCore;
